module.exports = __webpack_public_path__ + "images/f8d4cbcd808a0eef26900fac53afc8de.svg";